import React from 'react';
import { ArrowUpRight, BedDouble, Building2, Sparkles } from 'lucide-react';
import { RouteLink } from '../lib/router';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
const PATHWAYS = [{
  title: 'Stay Overnight',
  description: 'Boutique accommodation with sauna, hot tub and nature.',
  to: '/stay',
  action: 'Learn more',
  icon: BedDouble,
  image: 'https://a0.muscache.com/im/pictures/hosting/Hosting-U3RheVN1cHBseUxpc3Rpbmc6NDI3MDQ0NzQ%3D/original/f8c79b29-e4b3-444c-a36f-e29b7eb7c294.jpeg?im_w=1440',
  fallback: 'https://cdn.magicpatterns.com/uploads/6iFuFQHxKtTVkDK3NtymqK/543114991_122198079788570946_2516265263527440324_n.jpg'
}, {
  title: 'Pines Membership',
  description: 'Make Pines Retreat part of your weekly routine.',
  to: '/membership',
  action: 'View membership',
  icon: Sparkles,
  image: 'https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg',
  fallback: 'https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg'
}, {
  title: 'Retreat Space',
  description: 'Host your own retreat, workshop or private gathering.',
  to: '/space',
  action: 'Explore the space',
  icon: Building2,
  image: 'https://cdn.magicpatterns.com/uploads/si58DhwUTRVDDXyowrNiAy/2.jpg',
  fallback: 'https://cdn.magicpatterns.com/uploads/hffDynZX3nXn2CNTPNVY6M/471428511_122131322642570946_6342459253165615123_n.jpg'
}];
export function PathwayCards() {
  return <section className="bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-476" data-mp="vwqtwcswvpw">
      <div className="mx-auto max-w-6xl" data-id="element-477" data-mp="3s16cjbtrintp">
        <FadeIn data-id="element-478" data-mp="3s2hct1o01dg2">
          <h2 className="mb-12 max-w-2xl font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-479" data-mp="3s2zieowjx40n">
            Three ways to enjoy Pines Retreat.
          </h2>
        </FadeIn>
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-480" data-mp="3j1j9ymparbz2">
          {PATHWAYS.map((pathway, index) => {
          const Icon = pathway.icon;
          return <FadeIn key={pathway.title} delay={index * 0.1} data-id="element-481" data-mp="3dez5dvj1y4py" data-mpi={index}>
                <RouteLink to={pathway.to} className="group flex h-full flex-col overflow-hidden rounded-sm border border-pine/15 bg-creamDeep transition-colors hover:border-pine/35" data-id="element-482" data-mp="3dcd1c5vde7ch">
                  <div className="relative aspect-[4/3] overflow-hidden" data-id="element-483" data-mp="3s2u17kscwp79">
                    <SafeImage src={pathway.image} fallbackSrc={pathway.fallback} alt={pathway.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-484" data-mp="x2lzgg4awz8" />
                    <div className="absolute inset-0 bg-gradient-to-t from-charcoal/55 to-transparent" data-id="element-485" data-mp="ex3n8x0ao6f8" />
                    <div className="absolute bottom-4 left-4 flex h-10 w-10 items-center justify-center rounded-sm bg-cream/90 text-pine" data-id="element-486" data-mp="jnabuwut3qxh">
                      <Icon className="h-5 w-5" data-id="element-487" data-mp="24co0wjo1cybm" />
                    </div>
                  </div>
                  <div className="flex flex-1 flex-col p-6" data-id="element-488" data-mp="1ze330qw9aqqc">
                    <h3 className="mb-3 font-serif text-2xl text-pine" data-id="element-489" data-mp="2d6spewfp5xnz">{pathway.title}</h3>
                    <p className="mb-6 font-light leading-relaxed text-clay" data-id="element-490" data-mp="294xqfyl8nwdd">
                      {pathway.description}
                    </p>
                    <span className="mt-auto inline-flex items-center gap-2 font-medium text-ember" data-id="element-491" data-mp="1lfwfo4oxo94x">
                      {pathway.action}
                      <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-492" data-mp="1ufrsedy50c72" />
                    </span>
                  </div>
                </RouteLink>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}